<div class="Customers overview-loyalty ui-g">

    <div class="ui-g-12 ui-lg-6">
        <h1 class="step-title">{{ translations.page_title }}</h1>
    </div>
    <div class="ui-g-12 ui-lg-12">
        <p-steps [model]="items" [(activeIndex)]="activeIndex" [readonly]="false"></p-steps>
        <kv-search-toolbar
                [dateBoxEnabled]="true"
                [date_structure]="searchModel.date_structure"
                [card_modes]="searchModel.card_modes"
                [clusters]="searchModel.cluster_list"
                [customersBoxEnabled]="false"
                [clusterFieldEnabled]="false"
                [selectedElapsedStart]="searchModel.selectedStartDate"
                [selectedElapsedEnd]="searchModel.selectedEndDate"
                [group_types]="searchModel.group_types"
                [groups]="searchModel.groups"
                [areas]="searchModel.areas"
                [stores]="searchModel.stores"
                [disableMutualExclusivity]="false"
                [storeSelectionMode]="Multi"
                appQFilter
                (onQFilter)="ApplyResult($event)"
        ></kv-search-toolbar>

        <div class="overview-container card ui-g-nopad">
            <app-promo-overview-main-kpi [hidden]="activeIndex !== 0" ></app-promo-overview-main-kpi>
            <app-promo-overview-products [hidden]="activeIndex !== 1"  ></app-promo-overview-products>
            <app-promo-overview-loyalty [hidden]="activeIndex !== 2" ></app-promo-overview-loyalty>
            <app-promo-overview-loyalty-1-1 [hidden]="activeIndex !== 3" ></app-promo-overview-loyalty-1-1>
        </div>

    </div>

</div>



// WEBPACK FOOTER //
// ./src/app/views/analytics/promo/overview/promo-overview.component.html